<template>
  <div class="loginPage">
    <header>
      <div>
        <div class="em">你好，</div>
        <div>欢迎开通富力钱包</div>
      </div>
      <div class="icon logo"></div>
    </header>
    <div class="login-box">
      <div class="login-box-item">
        <input type="tel" v-model="source.mobile" placeholder="输入手机号" autocomplete="false"/>
        <div class="icon cancel-icon" @click="clear()" v-if="typeof source.mobile === 'string' && source.mobile.length > 0"></div>
      </div>
      <div class="login-box-divide"></div>
      <div class="login-box-item" v-if="mode === 'normal_verify'">
        <input type="tel" v-model="source.verify_code" placeholder="输入验证码" autocomplete="false" @keyup.enter="login" />
        <span class="login-box-verify" v-show="source.mobile && source.mobile.length === 11" @click="sendVerifySMS">
          <template v-if="countdown === -1">获取验证码</template>
          <template v-else-if="countdown > 0">重新获取({{ countdown }} s)</template>
          <template v-else-if="countdown === 0">重新获取</template>
        </span>
      </div>
      <div class="login-box-item" v-else>
        <input type="password" v-model="source.password" placeholder="请输入密码" autocomplete="false" @keyup.enter="login" />
      </div>
      <div class="login-box-hint">
        温馨提示：未注册富力钱包的手机号，登录时将自动注册，登录即表示已阅读并同意
        <router-link to="/protocol">《钱包使用协议》</router-link>
      </div>
      <mt-button size="large" class="login-box-button" @click="login" :disabled="login_locked">登&nbsp;录</mt-button>
      <div class="loginMode" v-if="mode === 'normal_verify'" @click="changeMode('normal_password')">
        使用密码登陆
      </div>
      <div class="loginMode" v-if="mode === 'normal_password'" @click="changeMode('normal_verify')">
        使用短信验证码登陆
      </div>
    </div>
    <!-- <footer class="copyright">富力钱包由腾讯牵头发起设立的微众银行提供技术支持</footer> -->
  </div>
</template>

<script>
import { Indicator, Button, Toast, MessageBox } from 'mint-ui';
import { Get, Post } from '@/utils/http';

const phoneRegex = /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/;

export default {
  data () {
    return {
      source: {
        mobile:       null,
        password:     null,
        verify_code:  null,
      },
      verify_locked:  false,
      countdown:      -1,

      mode:           'normal_verify',   // Or, 'normal_password', 'bind_verify', 'bind_password'
      login_locked:   false,
    };
  },
  methods: {
    changeMode (mode) {
      this.mode = mode;
    },

    login () {
      if (this.login_locked) {
        return;
      }

      let url = '';
      if (this.mode === 'normal_verify') {
        url = '/v1/person/user/login_with_verify';
      }
      if (this.mode === 'normal_password') {
        url = '/v1/person/user/login_with_password';
      }

      if (!this.source.mobile || !phoneRegex.test(this.source.mobile)) {
        this.$toast('请输入有效的手机号码');
        return;
      }

      if (!url) {
        this.$toast('登陆方法错误');
        return;
      } else if (this.mode === 'normal_verify' && !this.source.verify_code) {
        this.$toast('请输入短信验证码');
        return;
      } else if (this.mode === 'normal_password' && !this.source.password) {
        this.$toast('请输入密码');
        return;
      }

      Indicator.open();
      this.login_locked = true;
      Post(url, this.source).then((data)=>{
        Indicator.close();
        this.login_locked = false;

        localStorage.removeItem('mobile_login');
        localStorage.removeItem('lastSendSMSTime_login');
        this.toMain();
      }).catch(({ code, msg }) => {
        Indicator.close();
        this.login_locked = false;

        if (code === 28101) {
          this.$router.replace('/createGateway');
        } else if (code === 28126 || code === 28114) {
          this.$router.replace('/');
        } else {
          Toast({
            message:  `${code}: ${msg}`,
            duration: 3000,
          });
        }
      });
    },

    clear () {
      this.source.mobile = null;
      this.source.password = null;
      this.source.verify_code = null;
    },

    startCountdown () {
      this.countdown = 60;
      this.verify_locked = true;
      const t = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.countdown = 0;
          this.verify_locked = false;
          clearInterval(t);
        }
      }, 1000);
    },
    sendVerifySMS () {
      if (!this.source.mobile || !phoneRegex.test(this.source.mobile)) {
        this.$toast('请输入有效的手机号码');
        return;
      }

      if (this.countdown > 0) {
        this.$toast('两次获取验证码间隔不能小于60秒');
        return;
      }

      const url = '/v1/person/user/send_mobile_sms';
      const params = {
        mobile:         this.source.mobile,
        redirect_url:   `${window.location.origin}${window.location.pathname}?mobile=${this.source.mobile}&mode=normal_verify`,
      };

      if (this.source.mobile) {
        const lastSendSMSTime = localStorage.getItem('lastSendSMSTime_login');
        if (!lastSendSMSTime || parseInt(lastSendSMSTime) < (+new Date() - 60 * 1000)) {
          localStorage.setItem('mobile_login', this.source.mobile);
          localStorage.setItem('lastSendSMSTime_login', +new Date());

          Indicator.open();
          Post(url, params).then((data)=>{
            this.startCountdown();
            Indicator.close();
            Toast({
              message:  `验证码已发送`,
              duration: 3000,
            });
            if (data && data.captcha_url) {
              window.location.assign(data.captcha_url);
            }
          }).catch(({ code, msg, data }) => {
            Indicator.close();
            if (code === 2033) {
              window.location.assign(data.captcha_url);
            } else {
              Toast({
                message:  `${code}: ${msg}`,
                duration: 3000,
              });
            }
          });
        } else {
          this.$toast('两次获取验证码间隔不能小于60秒');
        }
      } else {
        this.$toast('请输入手机号码');
      }
    },

    toMain () {
      this.$router.replace('/main');
    },
  },
  mounted () {
    if (this.$route.query.mode && this.$route.query.mobile) {
      this.source.mobile = this.$route.query.mobile;
      this.mode = this.$route.query.mode;
    } else if (localStorage.mobile) {
      this.source.mobile = localStorage.getItem('mobile_login');
      localStorage.removeItem('mobile_login');
    }

    // if (localStorage.lastSendSMSTime) {
    //   const lastSendSMSTime = parseInt(localStorage.lastSendSMSTime_login);
    //   const now = +new Date();
    //   const delta = parseInt((now - lastSendSMSTime) / 1000);

    //   if (delta < 60) {
    //     this.startCountdown();
    //   }
    // }
  },
};
</script>

<style lang="less">
.loginPage {
  box-sizing:   border-box;
  height:       100%;
  width:        100%;
  padding:      40px 30px;

  background:   white;

  display:  flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  a {
    color:    #41a2ff;
  }

  header {
    width: 100%;
    display:  flex;
    align-items: center;
    justify-content: space-between;

    font-size:  .12rem;
    color:      #97a4b8;

    .em {
      font-weight:  bold;
      font-size:    .22rem;
      color:        #333;
    }
  }

  .login-box {
    flex:   1;
    padding-top:  85px;
  }

  .login-box-divide {
    width:    100%;
    margin:   .5em 0;
    border:   1.5px solid #e3e1ee;
  }

  .login-box-item {
    width: 100%;
    display:  flex;
    align-items: center;
    justify-content: space-between;

    input {
      display:  block;
      width:    100%;
      border:   none;
      outline:  none;
      color:  #333;
      background:   transparent;
      font-size:    22px;
      font-weight:  bold;
      padding:      0;

      &::-webkit-input-placeholder {
        color:        #97a4b8;
        font-weight:  normal;
      }
    }
    .login-box-verify {
      display:      block;
      color:        #41a2ff;
      font-size:    14px;
      width:        10em;
      text-align:   right;
      font-weight:  bold;
    }
  }
  .login-box-button {
    width: 100%;
    background:   #41a2ff;
    color:        white;
    font-size:      16px;
    // margin-top:     20px;
    margin-bottom:  30px;
    font-weight:    bold;
  }

  .login-box-hint {
    font-size:    12px;
    color:        #97a4b8;
    padding:      50px 0 15px;
    font-weight:  bold;
  }

  .loginMode {
    margin-bottom:  10px;
    color:      #97a4b8;
    font-size:    12px;
    text-align:   right;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue